<div class="supplier-wrapper">

    <h2>Add Employee </h2>
    <table class="form-section">
      <tr>
        <td> GID: </td>
        <td> <input type="text" class="input input-sm" [(ngModel)]="gid"> </td>
      </tr>
      <tr>
        <td> Site: </td>
        <td> 
            <select class="input input-sm flex-1" type="text" [(ngModel)]="site">
                <option>Flanders</option>
                <option>Swords</option>
                <option>Llanberis</option>
                <option>Los Angeles</option>
            </select>
        </td>
      </tr>
      <tr>
        <td> Role: </td>
        <td> 
            <select class="input input-sm flex-1" type="text" [(ngModel)]="role">
                <option>Admin</option>
                <option>Inspector</option>
            </select>
        </td>
      </tr>
    </table>


    <mat-dialog-actions>
      <button id="cancel-button" class="button button-cancel" (click)="cancel()"> Cancel </button>
        <span class="gutter"></span>
      <button id="submit-button" class="button button-submit" (click)="submit()"> Submit </button>
    </mat-dialog-actions>

</div>
